import {Injectable} from "@angular/core";
import {DxSessionRefreshStrategy} from "./dx-session-refresh-strategy";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Observable} from "rxjs";
import {fromPromise} from "rxjs/internal-compatibility";
import {DxSessionRefreshResult} from "../../../domain/user/dx-session-refresh-result";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";


/**
 *  Стратегия обновления сессий для BASIC Authentication
 */
@Injectable()
export class DxBasicSessionRefreshStrategy implements DxSessionRefreshStrategy {

  constructor() { }

  /** Дамми-метод обновления сессии */
  public refreshSession(session: DxUserSession): Observable<DxSessionRefreshResult> {
    const promise = new Promise<DxSessionRefreshResult>((resolve) => {
      const result: DxSessionRefreshResult = new DxSessionRefreshResult();
      result.type = DxOperationResultType.SUCCESS;
      resolve(result);
    });
    return fromPromise<DxSessionRefreshResult>(promise);
  }
}
